<div class="cell-actions">
  <mat-form-field>
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="filter" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <lcm-po-select (poSelected)="filterPo.set($event)"></lcm-po-select>
</div>

<table mat-table matSort [dataSource]="source()" [trackBy]="trackBy">
  <ng-container matColumnDef="ClientCode">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Client Code</th>
    <td mat-cell *matCellDef="let item">{{ item.ClientCode }}</td>
  </ng-container>

  <ng-container matColumnDef="JobNumber">
    <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Job number">#</th>
    <td mat-cell *matCellDef="let item">{{ item.JobNumber }}</td>
  </ng-container>

  <ng-container matColumnDef="Title">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Title</th>
    <td mat-cell *matCellDef="let item">
      <a [routerLink]="[item.LinkBase, item.JobNumber]"> {{ item.Title }} </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="Type">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let item">{{ item.Type }}</td>
  </ng-container>

  <ng-container matColumnDef="ProductOwner">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Product Owner</th>
    <td mat-cell *matCellDef="let item">{{ item.ProductOwner }}</td>
  </ng-container>

  <ng-container matColumnDef="Status">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let item">{{ item.Status }}</td>
  </ng-container>

  <ng-container matColumnDef="_Timestamp">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Refreshed</th>
    <td mat-cell *matCellDef="let item">
      @if (item._Loaded) {
        <span class="flex flex--row">
          @if (!item._LastUpdated) {
            <span class="mat-text-error">Request error</span>
          } @else {
            {{ item._LastUpdated }}
          }
        </span>
      } @else {
        <mat-icon class="rotating">refresh</mat-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="_Time">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      <div class="flex flex--row">
        <span matTooltip="Hours remaining" matTooltipPosition="above">
          {{ totalHours() | number: '.0-2' }}
        </span>
        @if (filteredItems() | sumBy: 'NotInvoicedYet') {
          <span matTooltip="Not invoiced yet">
            ({{ filteredItems() | sumBy: 'NotInvoicedYet' | number: '.0-2' }})
          </span>
        }
      </div>
    </th>
    <td mat-cell *matCellDef="let item" [class.mat-text-error]="item._Time < 0">
      <div class="flex flex--row flex--wrap">
        <span>{{ item._Time }}</span>
        @if (item.NotInvoicedYet > 0) {
          <span matTooltip="Not invoiced yet"> ({{ item.NotInvoicedYet }}) </span>
        }
        @if (item._Holded && item.ServiceType !== 'AWS Hosting') {
          <mat-icon class="mat-text-error" matTooltip="No worklog records during last 3 months">warning</mat-icon>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef style="text-align: center">
      <mat-icon matTooltip="Actions">settings_suggest</mat-icon>
    </th>
    <td mat-cell *matCellDef="let item">
      <div class="flex">
        <button
          target="_blank"
          [routerLink]="[item.LinkBase, item.JobNumber, { 'edit-form': true }]"
          matIconButton
          matTooltip="{{ item.BudgetNote || '' }}"
          matTooltipPosition="before"
        >
          <mat-icon>
            @if (item.BudgetNote) {
              chat
            } @else {
              chat_bubble_outline
            }
          </mat-icon>
        </button>

        <button matMiniFab (click)="refreshOne(item)">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToShow()"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToShow()"></tr>
</table>
